import { render, staticRenderFns } from "./ScanHubsPage.vue?vue&type=template&id=195653e7"
import script from "./ScanHubsPage.vue?vue&type=script&lang=js"
export * from "./ScanHubsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports